import React, { useEffect, useMemo } from "react";
import { useIterableParts } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { ProductConfiguratorPart } from "./ProductConfiguratorPart";

export const ProductConfiguratorForm = ({
  orderCode,
  activePart,
  isModalView,
  isConfigurationModalOpened,
  seriesId,
  setActivePart,
  modalBodyRef,
}) => {
  const allowedIterableParts = useIterableParts();

  useEffect(() => {
    if (activePart) {
      const partParent = document.getElementById(
        isConfigurationModalOpened
          ? `modal-part-id-${activePart}`
          : `part-id-${activePart}`,
      );

      partParent.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [activePart, isConfigurationModalOpened]);

  const configuration = useMemo(() => {
    const { parts } = orderCode;
    const config = {};
    parts?.forEach((part) => {
      part.options?.forEach((opt) => {
        config[`${part.key}-${opt.key}`] =
          opt.currentSignature?.key || opt.currentSignature?.value;
      });
    });
    return config;
  }, [orderCode]);

  const allowedIterablePartsSet = useMemo(
    () =>
      new Set(
        allowedIterableParts?.flatMap((part) =>
          part.options.map((opt) => `${part.partKey}-${opt.optionKey}`),
        ),
      ),
    [allowedIterableParts],
  );

  return (
    <>
      {orderCode.parts.map(
        (part) =>
          // state 2: The part/option is not relevant to the order code (i.e., its presentation does not contribute to the order code)
          // explanation of part.state is here https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_wiki/wikis/TROX-System-Configurator.wiki/1132/Product-states
          (part.state < 2 || (part.state === 3 && part.presentation)) && (
            <ProductConfiguratorPart
              key={part.key}
              part={part}
              configuration={configuration}
              activePart={activePart}
              isModalView={isModalView}
              isConfigurationModalOpened={isConfigurationModalOpened}
              seriesId={seriesId}
              setActivePart={setActivePart}
              modalBodyRef={modalBodyRef}
              allowedIterablePartsSet={
                allowedIterableParts && allowedIterablePartsSet
              }
            />
          ),
      )}
    </>
  );
};
